(function () {
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  var drawer, overlay, panel, itemsEl, countEl, subtotalEl, closeBtn, toastWrap;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function renderItem(item) {
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    var img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_200x$1$2') : '';
    return (
      '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item-img">' + (img ? '<img src="' + img + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '">' : '') + '</div>' +
        '<div class="cart-item-info">' +
          '<h4>' + item.product_title + '</h4>' +
          (variant ? '<div class="cart-item-variant">' + variant + '</div>' : '') +
          '<div class="cart-item-row">' +
            '<div class="cart-item-qty">' +
              '<button type="button" class="cart-qty-minus" aria-label="Diminuer">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" class="cart-qty-plus" aria-label="Augmenter">+</button>' +
            '</div>' +
            '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
          '<button type="button" class="cart-item-remove">Retirer</button>' +
        '</div>' +
      '</div>'
    );
  }

  function render(cart) {
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cart-drawer-empty">Votre panier est vide.<br><a href="/collections/all" class="btn-outline">Voir la boutique</a></div>';
    } else {
      itemsEl.innerHTML = cart.items.map(renderItem).join('');
    }
    subtotalEl.textContent = formatMoney(cart.total_price);
    countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    updateHeaderBadge(cart.item_count);
  }

  function updateHeaderBadge(count) {
    var cartLink = qs('.header-icons a[aria-label="Panier"]');
    if (!cartLink) return;
    var badge = qs('.cart-badge', cartLink);
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-badge';
        cartLink.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function showToast(html, isError) {
    if (!toastWrap) return;
    var toast = document.createElement('div');
    toast.className = 'cart-toast' + (isError ? ' is-error' : '');
    toast.innerHTML = html;
    toastWrap.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 350);
    }, 3200);
  }

  function showAddedToast(item) {
    var img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_80x$1$2') : '';
    showToast(
      (img ? '<div class="cart-toast-img"><img src="' + img + '" alt=""></div>' : '<div class="cart-toast-check"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></div>') +
      '<span><strong>' + item.product_title + '</strong> ajouté au panier</span>'
    );
  }

  function showErrorToast(message) {
    showToast('<span>' + message + '</span>', true);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function addItem(variantId, quantity, opts) {
    opts = opts || {};
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (addedItem) {
        if (opts.toast !== false) showAddedToast(addedItem);
        return fetchCart();
      })
      .then(function () {
        if (opts.openDrawer !== false) open();
      })
      .catch(function (err) {
        var message = (err && err.description) || 'Impossible d\'ajouter ce produit au panier.';
        showErrorToast(message);
        throw err;
      });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function init() {
    drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    overlay = qs('.cart-drawer-overlay', drawer);
    panel = qs('.cart-drawer-panel', drawer);
    itemsEl = document.getElementById('cart-drawer-items');
    countEl = document.getElementById('cart-drawer-count');
    subtotalEl = document.getElementById('cart-drawer-subtotal-amount');
    closeBtn = document.getElementById('cart-drawer-close');

    toastWrap = document.createElement('div');
    toastWrap.className = 'cart-toast-wrap';
    document.body.appendChild(toastWrap);

    overlay.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var cartLink = qs('.header-icons a[aria-label="Panier"]');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart();
        open();
      });
    }

    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.cart-item');
      if (!row) return;
      var key = row.dataset.key;
      if (e.target.classList.contains('cart-qty-plus')) {
        var current = parseInt(qs('span', row).textContent, 10);
        changeLine(key, current + 1);
      } else if (e.target.classList.contains('cart-qty-minus')) {
        var current2 = parseInt(qs('span', row).textContent, 10);
        changeLine(key, Math.max(0, current2 - 1));
      } else if (e.target.classList.contains('cart-item-remove')) {
        changeLine(key, 0);
      }
    });

    // Quick-buy buttons on product cards
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.qb-buy');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';
      addItem(variantId, 1).catch(function () {}).finally(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
    });

    // Product page form (two actions: add to cart, or buy now → checkout)
    var productForm = qs('.product-form');
    if (productForm) {
      var lastSubmitter = null;
      qsa('button[type="submit"]', productForm).forEach(function (b) {
        b.addEventListener('click', function () { lastSubmitter = b; });
      });
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitter = e.submitter || lastSubmitter || qs('.btn-buy', productForm);
        var action = submitter && submitter.dataset.action === 'buy' ? 'buy' : 'cart';
        var formData = new FormData(productForm);
        var variantId = formData.get('id');
        var qty = formData.get('quantity') || 1;
        var originalText = submitter ? submitter.textContent : '';
        if (submitter) { submitter.disabled = true; submitter.textContent = '...'; }
        addItem(variantId, parseInt(qty, 10), {
          openDrawer: action !== 'buy',
          toast: action !== 'buy'
        })
          .then(function () {
            if (action === 'buy') window.location.href = '/checkout';
          })
          .catch(function () {})
          .finally(function () {
            if (submitter) { submitter.disabled = false; submitter.textContent = originalText; }
          });
      });
    }

    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
